import form from "./schemas/form";
import validations from "./schemas/validations";
import { useEffect, useState } from "react";
import initialValues from "./schemas/initialValues";
import axios from "axios";
import { API_URL } from "../../../config";
import { useParams } from 'react-router-dom';
import {getProductService, updateProductService} from "../../../services/productService";
import {getPayoutService, updatePayoutService} from "../../../services/payoutService";

const useEditPayout = () => {

    const { id } = useParams();

    const {formId, formField} = form;

    const [values, setValues] = useState(initialValues);

    const [isLoading, setIsLoading] = useState(true);

    const [snackbarConfig, setSnackbarConfig] = useState({
        color: 'success',
        title: '',
        message: '',
        icon: 'notifications'
    });
    const [show, setShow] = useState(false);
    const toggleSnackbar = () => setShow(!show);

    useEffect(() => {
        const init = async () => {
            setIsLoading(true);
            await loadRecord();
            setIsLoading(false);
        };

        init();
    }, []);

    const loadRecord = async () => {
        try {
            const response = await getPayoutService(id);
            setValues(response.data.data);
        } catch (error) {
            setSnackbarConfig({
                message: "Ocurrió un error cargando el pago.",
                icon: 'cancel',
                title: 'Pagos',
                color: 'warning'
            });

            setShow(true);
        }
    };

    const handleSubmit = async (values, actions) => {
        try {
            // Send data to API
            await updatePayoutService(id, values)

            setSnackbarConfig({
                message: 'Pago actualizado exitosamente',
                icon: 'notifications',
                title: 'Pagos',
                color: 'success'
            });

            setShow(true);

        } catch (error) {
            setSnackbarConfig({
                message: error.response.data.message,
                icon: 'cancel',
                title: 'Pagos',
                color: 'warning'
            });

            setShow(true);
        }

        actions.setSubmitting(false);
    };

    return {
        formId,
        formField,
        validations,
        values,
        isLoading,
        snackbarConfig,
        show,
        toggleSnackbar,
        handleSubmit
    }
};

export default useEditPayout;
